import axios from "axios";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isKillSwitchEnabled } from "../services/featureFlag";

const useUnleashFeatureFlagAdapter = () => {
  const userId = useSelector((state) => state.auth.user?.id);
  const apiKey = process.env.REACT_APP_FEATURE_FLAG_API_KEY;
  const baseUrl = process.env.REACT_APP_JUSFY_FEATURE_FLAG_API_URL;

  const fetchFlagEnabled = (flagName) => isKillSwitchEnabled(flagName);

  const fetchUserFlagEnabled = async (flagName) => {
    try {
      if (!userId) {
        console.warn(
          `useFeatureFlag: userId is required for permission flag "${flagName}"`
        );
        return false;
      }
      const { data } = await axios.get(
        `${baseUrl}/unleash/has-permission-by-user-id/${flagName}/${userId}`,
        {
          headers: { "x-api-key": apiKey },
        }
      );
      return data;
    } catch (error) {
      console.log("error ao buscar flags", error);
      return false;
    }
  };

  return useMemo(
    () => ({
      isEnabled: fetchFlagEnabled,
      isUserEnabled: fetchUserFlagEnabled,
      flagsReady: true,
    }),
    [userId]
  );
};

export default useUnleashFeatureFlagAdapter;
